import React, { useEffect, useState, useRef } from "react";
import { Modal, ConfigProvider } from "antd";
import ApiService from "../../utils/ApiService";
import InvoicePreview from "../restaurants/orders/InvoicePreview";
import useUserStore from "../../stores/store";
import { PrinterOutlined } from "@ant-design/icons";
import { processAndSendPrintCommand } from "../../services/order-processing-service";
import { getFormatedOrderDetailsData } from "../../services/order-details-service";
import useScrollLock from "../../hooks/useScrollLock";

function DisplayInvoice({ openModal, records }) {
  // Lock scroll when modal is open
  useScrollLock(openModal);
  const { user, restaurantName, showNotification } = useUserStore();
  const buttonRef = useRef(null);
  const [isloading, setIsLoading] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  const [foodItems, setFoodItems] = useState([]);
  const [isShowInvoice, setIsShowInvoice] = useState(true);

  const handleCancel = () => {
    setOrderDetails(null);
    setFoodItems([]);
    setIsShowInvoice(false);
    records.onCancel();
  };

  const handlePrint = async (printPurpose) => {
    processAndSendPrintCommand(orderDetails, user.token.token, showNotification, printPurpose, true)
  };

  const fetchOrderDetail = async () => {
    setIsLoading(true);
    const res = await ApiService.FETCH_ORDER_DETAILS(
      records.param.orderId,
      user.token.token
    );

    if (res.status !== "ok") {
      showNotification(res.data.message);
      return;
    }

    const data = res.payload.record;
    
    const orderDetailsData = getFormatedOrderDetailsData(data);
    
    setOrderDetails(orderDetailsData);

    if (data?.foods?.length > 0 || data?.setMenus?.length > 0) {
      const extractedFoodItems = [
        ...(data?.foods || []),
        ...(data?.setMenus || []),
      ].map((item) => ({
        _id: item._id,
        foodName: item.foodName,
        quantity: item.quantity,
        totalPrice: item.totalPrice,
      }));
      setFoodItems(extractedFoodItems);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    setIsShowInvoice(true);
    if (openModal) {
      const fetchInitialData = async () => {
        await fetchOrderDetail();
      };

      fetchInitialData();
    }
  }, [openModal]);
  
  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultHoverBorderColor: "#FFD700",
            defaultHoverColor: "#000000",
            fontFamily: "ubold",
          },
        },
      }}
    >
      <Modal
        maskClosable={false}
        open={openModal}
        loading={isloading}
        okButtonProps={{
          style: {
            backgroundColor: "#FFD700",
            color: "#000000",
            fontFamily: "ubold",
          },
        }}
        onCancel={handleCancel}
        footer={[
          <button
          ref={buttonRef}
            key="Close"
            onClick={handleCancel}
            style={{
              backgroundColor: "#FF4D4F",
              color: "#FFFFFF",
              fontFamily: "ubold",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
              marginRight: "10px",
            }}
          >
            Close
          </button>,

          <button
            key="kitchenSlipOrInvoice"
            onClick={() => handlePrint(1)}
            style={{
              backgroundColor: "#D9D9D9",
              color: "#000000",
              fontFamily: "ubold",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
              marginRight: "10px",
            }}
          >
            <PrinterOutlined /> Kitchen Slip
          </button>,

          <button
            key="printOrDownload"
            onClick={() => handlePrint(3)}
            style={{
              backgroundColor: "#FFD700",
              color: "#000000",
              fontFamily: "ubold",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            <PrinterOutlined /> Invoice
          </button>,
        ]}
      >
        
        {isShowInvoice && (
          <>
            <div className="w-full">
              <InvoicePreview
                orderDetails={orderDetails}
                foodItems={foodItems}
                buttonRef={buttonRef}
              />
            </div>
          </>
        )}
      </Modal>
    </ConfigProvider>
  );
}

export default DisplayInvoice;
